import MatchingSelectSchoolsWrapper from './MatchingSelectSchoolsWrapper.page';

export default MatchingSelectSchoolsWrapper;
